import i18n from "i18next";
import type { FC } from "react";

import { SecondaryButton } from "../Buttons/components/ActionButton";

export type ResetButtonProps = {
    isDisabled: boolean;
    callback: () => void;
};

export const ResetButton: FC<ResetButtonProps> = ({ isDisabled, callback }) => {
    return (
        <SecondaryButton name="reset_button" onClick={callback} disabled={isDisabled}>
            {i18n.t("button.reset")}
        </SecondaryButton>
    );
};
